import React from 'react';

import { Field, Form } from 'react-final-form';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import AuthTitle from 'components/shared/Typography/AuthTitle';
import Text from 'components/shared/Typography/Text';
import useValidationSchema from 'hooks/useValidationSchema';

import { useLookUp } from './functions';
import s from './index.module.css';
import { validationSchema } from './validationSchema';

function LookUp() {
  const { lookup, isNotFoundedEmail } = useLookUp();
  const validate = useValidationSchema(validationSchema);

  return (
    <Form onSubmit={(values) => lookup.mutate(values)} validate={validate}>
      {({ handleSubmit, submitting, hasValidationErrors }) => {
        return (
          <form onSubmit={handleSubmit} autoComplete="off">
            {/* @ts-ignore */}
            <AuthTitle>Enter your email</AuthTitle>
            <Field component={FormGroupAdapter} name="email" placeholder="Email" type="text" />

            {isNotFoundedEmail && (
              <Text type="danger" size="small" className={s.error} accent>
                The email address used here must match the one that was sent the Guest Portal invitation.
              </Text>
            )}

            <FormActions isRight>
              <Button htmlType="submit" disabled={submitting || hasValidationErrors}>
                Continue
              </Button>
            </FormActions>
          </form>
        );
      }}
    </Form>
  );
}

export default LookUp;
